export default "__VITE_ASSET__42d51596__"